export const messages = {
  en: {
    itemReleaseFinish: {
      page: {
        title: 'Finished Release Orders',
        subtitle: 'View completed release orders',
        empty: 'No finished orders found'
      },
      title: 'Finished Release Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderNo: 'Order No',
      releaseType: 'Release Type',
      applyUnit: 'Apply Unit',
      applicant: 'Applicant',
      idCard: 'ID Card',
      phone: 'Phone',
      passTime: 'Pass Time',
      items: 'Items',
      viewItems: 'View Items',
      status: 'Status',
      plateNo: 'Plate No',
      none: 'None',
      operation: 'Operation',
      detail: 'Detail',
      fetchError: 'Failed to fetch data'
    },
  },
  zh: {
    itemReleaseFinish: {
      page: {
        title: '放行已办单',
        subtitle: '查看已完成的放行单',
        empty: '暂无已办单数据'
      },
      title: '放行已办单',
      back: '返回',
      refresh: '刷新',
      orderNo: '单号',
      releaseType: '放行类型',
      applyUnit: '申请单位',
      applicant: '申请人',
      idCard: '身份证',
      phone: '手机号',
      passTime: '通行时间',
      items: '物品',
      viewItems: '查看物品',
      status: '状态',
      plateNo: '车牌号',
      none: '无',
      operation: '操作',
      detail: '详情',
      fetchError: '获取数据失败'
    },
  }
}